// src/pages/Cart.js
import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import CartItem from '../components/cart/CartItem';
import CartSummary from '../components/cart/CartSummary';
import { fadeIn } from '../utils/gsapAnimations';

function Cart() {
  const pageRef = useRef(null);
  const { cart } = useCart();

  useEffect(() => {
    fadeIn(pageRef.current, 0.3);
  }, []);

  return (
    <div ref={pageRef} className="min-h-screen bg-cream py-6 sm:py-12 lg:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-6 flex items-end justify-between sm:mb-10">
          <div>
            <p className="text-xs font-bold uppercase tracking-[.18em] text-primary/60">Your order</p>
            <h1 className="mt-1 text-3xl font-playfair-display font-semibold text-primary sm:text-4xl lg:text-5xl">Basket</h1>
          </div>
          {cart.length > 0 && <span className="rounded-full bg-primary/10 px-3 py-1.5 text-xs font-bold text-primary">{cart.reduce((sum, item) => sum + Number(item.quantity || 0), 0)} items</span>}
        </div>

        {cart.length > 0 ? (
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-12">
            {/* Cart Items */}
            <div className="space-y-3 lg:col-span-2 lg:space-y-5">
              {cart.map((item) => (
                <div
                  key={item.variantKey}
                  className="overflow-hidden rounded-2xl border border-gray-100/70 bg-white shadow-sm transition-all duration-300 hover:shadow-lg"
                >
                  <CartItem item={item} />
                </div>
              ))}
            </div>

            {/* Summary Sidebar */}
            <div className="lg:col-span-1">
              <div className="sticky top-24 rounded-2xl border border-gray-100 bg-white shadow-lg">
                <CartSummary />
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center py-16 lg:py-24">
            <div className="max-w-md mx-auto">
              <p className="text-xl sm:text-2xl font-montserrat text-primary mb-6 leading-relaxed">
                Your cart is empty.
              </p>
              <p className="text-lg font-montserrat text-secondary mb-10">
                Looks like you haven’t added anything yet. Start shopping now!
              </p>
              <Link
                to="/shop"
                className="inline-block bg-primary text-cream font-montserrat py-4 px-10 rounded-full text-lg hover:bg-primary/90 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5 duration-300"
                aria-label="Shop now"
              >
                Shop Now
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Cart;
